import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Spinner = styled.div<{ size?: string; color?: string }>`
  border: 3px solid ${({ theme }) => theme.colors.border};
  border-top: 3px solid ${({ color, theme }) => color || theme.colors.primary};
  border-radius: 50%;
  width: ${({ size }) => size || "40px"};
  height: ${({ size }) => size || "40px"};
  animation: ${spin} 1s linear infinite;
`;

export const PageLoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
`;

export const PageLoader = () => {
  return (
    <PageLoaderWrapper>
      <Spinner size="3rem" />
    </PageLoaderWrapper>
  );
};
